import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      // Al volver a la pestaña se vuelve a preguntar.
      //
      // Esto no es una optimización, es una regla de seguridad. Una cajera con
      // la pantalla abierta desde hace una hora ve la foto de hace una hora: el
      // paciente subió su Yape desde el celular hace diez minutos y en Caja
      // sigue apareciendo "por cobrar". Si ese paciente se acerca a ventanilla
      // —y con un problema de salud encima, cualquiera olvida que ya pagó— la
      // cajera le cobra otra vez.
      //
      // El backend rechaza el segundo cobro con un 409, así que el dinero no
      // corre peligro; lo que corre peligro es la confianza del paciente
      // mientras alguien discute en el mostrador. Nadie debería tener que
      // acordarse de pulsar F5 para que eso no pase.
      refetchOnWindowFocus: true,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("No root element found");

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
